<template>
  <div class="footer">
    <div class="box box-3 box-31" id="right-notice-box" v-if="centerNotice && centerMessage">
      <dl style="min-height: 200px; position: absolute; cursor: move; z-index: 1; padding-bottom: 25px">
        <dd>
          公告
          <b id="small_button" class="icon icon-up">X</b>
        </dd>
        <div style="">
          <div class="title" style="text-align: center;font-size:14px;font-weight:bolder;padding: 5px 0">{{centerMessage.title}}</div>
          <div id="right-notice" style="padding: 10px">{{centerMessage.content}}</div>
        </div>
        <div style="position: absolute; right: 5px; bottom: 5px">
          <span class="time">{{centerMessage.timeStamp | dateFormate}}</span>
        </div>
      </dl>
    </div>
    <div class="box box-3" id="right-notice-box-bottom" v-if="bottomNotice && bottomMessage">
      <dl style="min-height: 200px; position: absolute; z-index: 1; padding-bottom: 25px;">
        <dd>
          公告
          <b id="small_button_bottom" class="icon icon-up" ></b>
        </dd>
        <div style="">
          <div class="title" style="text-align: center;font-size:14px;font-weight:bolder;padding: 5px 0">{{bottomMessage.title}}</div>
          <div id="right-notice" style="padding: 10px">{{bottomMessage.content}}</div>
        </div>
        <div style="position: absolute; right: 5px; bottom: 5px">
          <span class="time">{{bottomMessage.timeStamp | dateFormate}}</span>
        </div>
      </dl>
    </div>
    <div id="myWarpr" v-if="ggc">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>消息</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 450px; height: auto; overflow-y: auto;">
                <div id="newsWrap" style="max-height:280px; overflow-y:auto;">
                  <table class="order">
                    <thead>
                      <tr>
                        <th width="450">消息内容</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in messageList" :key="index">
                        <td
                          style="word-wrap: break-word;word-break:break-all;text-align: left;padding-left: 10px"
                        >{{item.content}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="myLayerFooter" style="display: none;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="取消"
                  style="display: none;"
                  @click="closeWin()"
                >取消</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="确认"
                  style="display: none;"
                  @click="closeWin()"
                >确认</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="myWarpr" v-if="jsbb" style="">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>结算报表</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 750px; height: auto; overflow-y: auto;">
                <div id="result">
                  <div class="history_wrap">
                    <table>
                      <thead>
                        <tr>
                          <th rowspan="2" width="170">交易日期</th>
                          <th colspan="4" style="text-align:right;font-weight:normal;" id="myche">
                            <label style="margin:0 12px;">
                              总项
                              <input
                                type="radio"
                                name="che"
                                value="0"
                                checked="checked"
                                style="position:absolute; margin-top:3px; margin-left:2px;"
                              />
                            </label>
                          </th>
                          <th rowspan="2" width="170">实际结果</th>
                        </tr>
                        <tr>
                          <td class="bcg">注单数</td>
                          <td class="bcg">下注金额</td>
                          <td class="bcg">有效金额</td>
                          <td class="bcg">退水后结果</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          data-date="2020-03-02"
                          class="cursor"
                          v-for="(item,index) in dataList.slice(0,7)"
                          :key="index"
                          @click="reportDetail(item)"
                        >
                          <td>{{item.betDate +" "+item.week}}</td>
                          <td>{{item.num || 0}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.betMoney * 1).toFixed(2)}}</td>
                          <td
                            style="text-align:right;padding-right:5px;color:red;"
                          >{{(item.vaildMoney * 1).toFixed(2)}}</td>
                          <td
                            style="text-align:right;padding-right:5px;color:red;"
                          >{{(item.afterBackMoney * 1).toFixed(2)}}</td>
                          <td
                            style="text-align:right;padding-right:5px;color:red;"
                          >{{(item.actualMoney * 1).toFixed(2)}}</td>
                        </tr>
                        <tr>
                          <td class="bcg bold">上周</td><td class="bcg bold">{{sum(dataList.slice(0,7), 'num')}}</td>
                          <td class="bcg bold" style="text-align:right;padding-right:5px;">{{sum(dataList.slice(0,7), 'betMoney')}}</td>
                          <td class="bcg bold" style="text-align:right;padding-right:5px;color:red;">{{sum(dataList.slice(0,7), 'vaildMoney')}}</td>
                          <td class="bcg bold" style="text-align:right;padding-right:5px;color:red;">{{sum(dataList.slice(0,7), 'afterBackMoney')}}</td>
                          <td class="bcg bold" style="text-align:right;padding-right:5px;color:red;">{{sum(dataList.slice(0,7), 'actualMoney')}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div style="clear:both;margin-top:10px;"></div>
                     <table>
                      <thead>
                        <tr>
                          <th rowspan="2" width="170">交易日期</th>
                          <th colspan="4" style="text-align:right;font-weight:normal;" id="myche">
                            <label style="margin:0 12px;">
                              <!-- 总项
                              <input
                                type="radio"
                                name="che"
                                value="0"
                                checked="checked"
                                style="position:absolute; margin-top:3px; margin-left:2px;"
                              /> -->
                            </label>
                          </th>
                          <th rowspan="2" width="170">实际结果</th>
                        </tr>
                        <tr>
                          <td class="bcg">注单数</td>
                          <td class="bcg">下注金额</td>
                          <td class="bcg">有效金额</td>
                          <td class="bcg">退水后结果</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          data-date="2020-03-02"
                          class="cursor"
                          v-for="(item,index) in dataList.slice(7)"
                          :key="index"
                          @click="reportDetail(item)"
                        >
                          <td>{{item.betDate +" "+item.week}}</td>
                          <td>{{item.num || 0}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.betMoney * 1).toFixed(2)}}</td>
                          <td
                            style="text-align:right;padding-right:5px;color:red;"
                          >{{(item.vaildMoney * 1).toFixed(2)}}</td>
                          <td
                            style="text-align:right;padding-right:5px;color:red;"
                          >{{(item.afterBackMoney * 1).toFixed(2)}}</td>
                          <td
                            style="text-align:right;padding-right:5px;color:red;"
                          >{{(item.actualMoney * 1).toFixed(2)}}</td>
                        </tr>
                        <tr>
                          <td class="bcg bold">上周</td><td class="bcg bold">{{(sum(dataList.slice(7), 'num') * 1).toFixed(2)}}</td>
                          <td class="bcg bold" style="text-align:right;padding-right:5px;">{{(sum(dataList.slice(7), 'betMoney') * 1).toFixed(2)}}</td>
                          <td class="bcg bold" style="text-align:right;padding-right:5px;color:red;">{{(sum(dataList.slice(7), 'vaildMoney') * 1).toFixed(2)}}</td>
                          <td class="bcg bold" style="text-align:right;padding-right:5px;color:red;">{{(sum(dataList.slice(7), 'afterBackMoney') * 1).toFixed(2)}}</td>
                          <td class="bcg bold" style="text-align:right;padding-right:5px;color:red;">{{(sum(dataList.slice(7), 'actualMoney') * 1).toFixed(2)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="myLayerFooter" style="display: block;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="取消"
                  style="display: none;"
                  @click="closeWin()"
                >取消</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="确认"
                  style="display: inline-block;"
                  @click="closeWin()"
                >确认</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="myWarpr" v-if="bbDetails">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>结算报表</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 750px; height: auto; overflow-y: auto;">
                <div id="result">
                  <div class="MenuBox1">
                    <label class="cursor" @click="backToReport()">&lt;&lt;返回</label>
                  </div>
                  <div class="history_wrap MenuPadding-top">
                    <table>
                      <thead>
                        <tr>
                          <th>彩种类型</th>
                          <th>注单笔数</th>
                          <th>下注总额</th>
                          <th>有效总额</th>
                          <th>结果</th>
                          <th>退水</th>
                          <th>实际结果</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr @click="toIssueDetail(item)" class="cursor" mystate="3" v-for="(item, index) in openReportDetailList" :key="index">
                          <td>{{item.gameName}}</td>
                          <td>{{item.num}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.betMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.vaildMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;color:red;">{{(item.afterBackMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;color:red;">{{formatReportNumber(getDayReportBackValue(item))}}</td>
                          <td style="text-align:right;padding-right:5px;color:red;">{{(item.actualMoney * 1).toFixed(2)}}</td>
                        </tr>
                        <tr v-if="openReportDetailList.length == 0">
                          <td colspan="7">无未结算记录！</td>
                        </tr>
                        <tr class="bc bold">
                          <td>当前页合计</td>
                          <td>{{sum(openReportDetailList, 'num')}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(sum(openReportDetailList, 'betMoney') * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(sum(openReportDetailList, 'vaildMoney') * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(sum(openReportDetailList, 'afterBackMoney') * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{formatReportNumber(getDayReportBackTotal(openReportDetailList))}}</td>
                          <td style="text-align:right;padding-right:5px;color:red;">{{(sum(openReportDetailList, 'actualMoney') * 1).toFixed(2)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="myLayerFooter" style="display: block;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="取消"
                  style="display: none;"
                  @click="closeWin()"
                >取消</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="确认"
                  style="display: inline-block;"
                  @click="closeWin()"
                >确认</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="myWarpr" v-if="issueDetail">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0" style="">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>结算报表</h3><a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 950px; height: auto; overflow-y: auto;">
                <div id="1588581683628" style="max-height:520px; overflow-y:auto;">
                  <div id="result">
                    <div class="MenuBox1"><label class="cursor" @click="backToReport()">&lt;&lt;返回</label></div>
                    <div class="history_wrap MenuPadding-top">
                      <table>
                        <thead>
                          <tr>
                            <th>期数</th>
                            <th>笔数</th>
                            <th>下注金额</th>
                            <th>有效金额</th>
                            <th>中奖</th>
                            <th>回水</th>
                            <th>盈亏</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in issueDetailList.slice(0, showIssueDetailCount)" :key="index">
                            <td>{{item.qihao}}</td>
                            <td>{{item.issueNum}}</td>
                            <td style="text-align:right;padding-right:5px;">{{(item.betMoney * 1).toFixed(2)}}</td>
                            <td style="text-align:right;padding-right:5px;">{{(item.vaildMoney * 1).toFixed(2)}}</td>
                            <td style="text-align:right;padding-right:5px;">{{(item.drawMoney * 1).toFixed(2)}}</td>
                            <td style="text-align:right;padding-right:5px;">{{(item.backMoney * 1).toFixed(2)}}</td>
                            <td style="text-align:right;padding-right:5px;color:red;">{{(item.winorlose * 1).toFixed(2)}}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <th>当前页合计：<span name="data-count">{{issueDetailList.length}}</span>期</th>
                            <th style="text-align:right;padding-right:5px;"><span name="data-a">{{sum(issueDetailList.slice(0, showIssueDetailCount), 'issueNum')}}</span></th>
                            <th style="text-align:right;padding-right:5px;"><span name="data-b">{{(sum(issueDetailList.slice(0, showIssueDetailCount), 'betMoney') * 1).toFixed(2)}}</span></th>
                            <th style="text-align:right;padding-right:5px;"><span name="data-c">{{(sum(issueDetailList.slice(0, showIssueDetailCount), 'vaildMoney') * 1).toFixed(2)}}</span></th>
                            <th style="text-align:right;padding-right:5px;"><span name="data-d">{{(sum(issueDetailList.slice(0, showIssueDetailCount), 'drawMoney') * 1).toFixed(2)}}</span></th>
                            <th style="text-align:right;padding-right:5px;"><span name="data-e">{{(sum(issueDetailList.slice(0, showIssueDetailCount), 'backMoney') * 1).toFixed(2)}}</span></th>
                            <th style="text-align:right;padding-right:5px;color: red"><span name="data-f">{{(sum(issueDetailList.slice(0, showIssueDetailCount), 'winorlose') * 1).toFixed(2)}}</span></th>
                          </tr>
                        </tfoot>
                      </table>
                      <div id="fondiv" style="text-align:center;padding:1px 0;margin-top:2px;">
                        <a v-if="showIssueDetailCount <= issueDetailList.length -1" href="javascript:void(0);" @click="showMoreIssueDetail()">点击获取更多...</a>
                        <span v-else id="nodataTitle" class="">无数據加載！</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="myLayerFooter" style="display: block;"><a href="javascript:;" class="btn grayBtn myLayerCancel" title="取消"
                style="display: none;">取消</a><a href="javascript:;" class="btn hotBtn myLayerOk" title="确认" style="display: inline-block;"  @click="closeWin()">确认</a></div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="myWarpr" v-if="betLogDetailFlag">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>投注详情</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 750px; max-height:350px; height: auto; overflow-y: auto;">
                <div id="result">
                  <div class="history_wrap MenuPadding-top">
                    <table>
                      <thead>
                        <tr>
                          <th>号码</th>
                          <th>赔率</th>
                          <th>金额</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in betLogDetail" :key="index" class="cursor" mystate="3">
                          <td>{{item.number}}</td>
                          <td>{{item.peilv || '-'}}</td>
                          <td>{{(item.money * 1).toFixed(2)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="myWarpr" v-if="this.actionLogDetailFlag">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>提示</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 750px; max-height: 350px; height: auto; overflow-y: auto;">
                <div id="result">
                  <div class="history_wrap MenuPadding-top">
                    <table>
                      <thead>
                        <tr>
                          <th>类别</th>
                          <th>改前</th>
                          <th>改后</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in actionLogDetail" :key="index" class="cursor" mystate="3">
                          <td>{{item.sonProject}}</td>
                          <td>{{item.orgBack}}</td>
                          <td>{{item.back}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="myWarpr" v-if="historyJiang">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>历史开奖</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 780px; height: auto; overflow-y: auto;">
                <div id="1583976092718" style="max-height:590px; overflow-y:auto;">
                  <div id="result">
                    <div class="MenuBox2">
                      <label>
                        <select data-id="gameIndex" v-model="historyGameCode" @change="changeHistoryGame">
                          <option
                            v-for="(item, index) in popupGameList"
                            :key="'history-game-' + index"
                            :value="getPopupGameCode(item)"
                          >{{getPopupGameName(item)}}</option>
                        </select>
                      </label>
                    </div>
                    <div class="history_wrap MenuPadding-top">
                      <table>
                        <thead>
                          <tr>
                            <th class="w15">期数日期</th>
                            <th>期号</th>
                            <th>开奖结果</th>
                            <th v-if="historyResultFieldMap.sum">总和</th>
                            <th v-if="historyResultFieldMap.dx">总和大小</th>
                            <th v-if="historyResultFieldMap.ds">总和单双</th>
                            <th v-if="historyResultFieldMap.lhh">龙虎和</th>
                            <th v-if="historyFanColumns.length" v-for="column in historyFanColumns" :key="'history-fan-head-' + column.key">{{column.title}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            :class=" (index+1) % 2 == 0 ? 'bc' : '' "
                            v-for="(item,index) in historyList"
                            :key="index"
                          >
                            <td>{{formatHistoryTime(item.timeStamp)}}</td>
                            <td class="sw45">{{item.qihao}}</td>
                            <td>
                              <template v-for="(num, numIndex) in item.openNumbers">
                                <span
                                  :key="'text-' + numIndex"
                                  class="history-open-number"
                                >{{num}}</span>
                              </template>
                            </td>
                            <td v-if="historyResultFieldMap.sum" class="sw45">{{item.hasResult ? item.sum : ""}}</td>
                            <td v-if="historyResultFieldMap.dx" class="sw55" :class="[item.dx == '大' ? 'red' : '']">
                              {{item.dx}}
                            </td>
                            <td v-if="historyResultFieldMap.ds" class="sw55" :class="[item.ds == '双' ? 'red' : '']">
                              {{item.ds}}
                            </td>
                            <td v-if="historyResultFieldMap.lhh" class="sw45">{{item.lhh}}</td>
                            <td v-if="historyFanColumns.length" class="sw70" v-for="column in historyFanColumns" :key="'history-fan-' + column.key">{{item[column.key]}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div id="fondiv" style="text-align:center;padding:1px 0;margin-top:2px;">
                        <a v-if="historyList.length < historyCount" href="javascript:void(0);" @click="loadMore()">点击获取更多...</a>
                        <span v-else id="nodataTitle">无数據加載！</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="myLayerFooter" style="display: block;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="取消"
                  style="display: none;"
                  @click="closeWin()"
                >取消</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="确认"
                  style="display: inline-block;"
                  @click="closeWin()"
                >确认</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="myWarpr" v-if="changRoute" style="width: ">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>线路切换</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 370px; height: auto; overflow-y: auto;">
                <div id="result">
                  <div id="lineching" class="history_wrap">
                    <table class="infoList">
                      <tbody>
                        <tr >
                          <td class="w25 bc txt-right">线路1:</td>
                          <td class="txt-left">
                            <input
                              type="text"
                              class="text-input sw120"
                              disabled="disabled"
                              :value="'响应时间' + speedList[0].time"
                              placeholder="响应时间:测速中"
                            />
                            <input
                              type="radio"
                              style="vertical-align:middle"
                              name="radio"
                              v-model="choiceUrl"
                              :value="speedList[0].host"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="w25 bc txt-right">线路2:</td>
                          <td class="txt-left">
                            <input
                              type="text"
                              class="text-input sw120"
                              disabled="disabled"
                              :value="'响应时间' + speedList[1].time"
                            />
                            <input
                              type="radio"
                              style="vertical-align:middle"
                              name="radio"
                              v-model="choiceUrl"
                              :value="speedList[1].host"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="w25 bc txt-right">线路3:</td>
                          <td class="txt-left">
                            <input
                              type="text"
                              class="text-input sw120"
                              disabled="disabled"
                              :value="'响应时间' + speedList[2].time"
                            />
                            <input
                              type="radio"
                              style="vertical-align:middle"
                              name="radio"
                              v-model="choiceUrl"
                              :value="speedList[2].host"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="w25 bc txt-right">线路4:</td>
                          <td class="txt-left">
                            <input
                              type="text"
                              class="text-input sw120"
                              disabled="disabled"
                              :value="'响应时间' + speedList[3].time"
                            />
                            <input
                              type="radio"
                              style="vertical-align:middle"
                              name="radio"
                              v-model="choiceUrl"
                              :value="speedList[3].host"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="w25 bc txt-right">线路5:</td>
                          <td class="txt-left">
                            <input
                              type="text"
                              class="text-input sw120"
                              disabled="disabled"
                              :value="'响应时间' + speedList[4].time"
                            />
                            <input
                              type="radio"
                              style="vertical-align:middle"
                              name="radio"
                              v-model="choiceUrl"
                              :value="speedList[4].host"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="myLayerFooter" style="display: block;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="測速"
                  style="display: inline-block;"
                  @click="cs()"
                >測速</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="确认"
                  style="display: inline-block;"
                  @click="changeSure()"
                >确认</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="myWarpr" v-if="playgz">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>玩法规则</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 820px; height: 680px; overflow-y: auto;">
                <div class="WFBox" id="introduction">
                  <div class="MenuBox2">
                    <label>
                      <select data-id="gameIndex" v-model="playRuleGameCode" @change="changePlayRuleGame">
                        <option
                          v-for="(item, index) in popupGameList"
                          :key="'play-rule-game-' + index"
                          :value="getPopupGameCode(item)"
                        >{{getPopupGameName(item)}}</option>
                      </select>
                    </label>
                  </div>

                  <!--重慶时时彩-->
                  <div class="contentNode" style id="conNode_3">
                    <div class="box mt7" v-html="playGzMessage"></div>
                  </div>
                </div>
              </div>
              <div class="myLayerFooter" style="display: block;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="取消"
                  style="display: none;"
                  @click="closeWin()"
                >取消</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="确认"
                  style="display: inline-block;"
                  @click="closeWin()"
                >确认</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="myWarpr" v-if="xyzl">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>信用资料</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 1200px; height: auto; overflow-y: auto;">
                <div id="1583976974761" style="max-height:700px; overflow-y:auto;">
                  <div id="result">
                    <div class="history_wrap">
                      <table>
                        <thead>
                          <tr>
                            <th colspan="2">基本信息</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              class="bcg"
                              style="width:40%;text-align:right; padding-right:5px;"
                            >会员账号:</td>
                            <td style="text-align:left;padding-left:10px;">{{username}}</td>
                          </tr>
                          <tr>
                            <td
                              class="bcg"
                              style="width:40%;text-align:right; padding-right:5px;"
                            >状态:</td>
                            <td style="text-align:left;padding-left:10px;">{{state}}</td>
                          </tr>
                          <tr>
                            <td
                              class="bcg"
                              style="width:40%;text-align:right; padding-right:5px;"
                            >信用额度:</td>
                            <td style="text-align:left;padding-left:10px;">{{xyed}}</td>
                          </tr>
                          <tr>
                            <td
                              class="bcg"
                              style="width:40%;text-align:right; padding-right:5px;"
                            >可用额度:</td>
                            <td style="text-align:left;padding-left:10px;">{{kyed}}</td>
                          </tr>
                          <tr>
                            <td
                              class="bcg"
                              style="width:40%;text-align:right; padding-right:5px;"
                            >彩种:</td>
                            <td style="text-align:left;padding-left:10px;">
                              <select data-id="gameIndex" v-model="creditGameCode" @change="changeCreditGame">
                                <option
                                  v-for="(item, index) in popupGameList"
                                  :key="index"
                                  :value="getPopupGameCode(item)"
                                >{{getPopupGameName(item)}}</option>
                              </select>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div style="clear:both;margin-top:5px;"></div>
                      <div style="width:49.9%;float:left;">
                        <table>
                          <thead>
                            <tr>
                              <th>项目类型</th>
                              <th>单注最低</th>
                              <th>单注最高</th>
                              <th>单项最高</th>
                              <th>赔率上限</th>
                              <th>赚水</th>
                              <th>赔率</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="bcg">一定位</td>
                              <td colspan="7"></td>
                            </tr>
                            <tr
                              sort="1"
                              v-for="(item,index) in creditD1WList"
                              :key="item.sonProject"
                            >
                              <td class="bcg">{{item.sonProject}}</td>
                              <td>{{item.singleMin}}</td>
                              <td>{{item.singleMax}}</td>
                              <td>{{item.projectMax}}</td>
                              <td>{{item.peilvMax}}</td>
                              <td>
                                <select data-id="s_huishui" @change="changeLeftZH(item, 1, index, item.zs)" v-model="item.zs">
                                  <option :value="zs" v-for="(zs, zsIndex) in zuanshuiList" :key="zsIndex">{{zs}}</option>
                                </select>
                              </td>
                              <td>
                                <select data-id="s_odds"  @change="changeLeftPL(item, 1, index, item.peilv)" v-model="item.peilv">
                                  <!-- <option :value="item.peilv" selected>{{item.peilv}}</option> -->
                                  <option
                                    v-if="item.peilvMax*1 >= odds*1"
                                    v-for="(odds, oddsIndex) in creditOddsOptions(item, 1)"
                                    :key="oddsIndex" :value="odds">
                                    {{odds}}
                                  </option>
                                </select>
                              </td>
                            </tr>

                            <tr>
                              <td class="bcg">二定位</td>
                              <td colspan="7"></td>
                            </tr>
                            <tr
                              sort="108"
                              v-for="(item,index) in creditD2WList"
                              :key="item[index]"
                            >
                              <td class="bcg">{{item.sonProject}}</td>
                              <td>{{item.singleMin}}</td>
                              <td>{{item.singleMax}}</td>
                              <td>{{item.projectMax}}</td>
                              <td>{{item.peilvMax}}</td>
                              <td>
                                <select data-id="s_huishui" @change="changeLeftZH(item, 2, index, item.zs)" v-model="item.zs">
                                  <option :value="zs" v-for="(zs, zsIndex) in zuanshuiList" :key="zsIndex">{{zs}}</option>
                                </select>
                              </td>
                              <td>
                                <select data-id="s_odds" @change="changeLeftPL(item, 2, index, item.peilv)" v-model="item.peilv">
                                  <!-- <option :value="item.back" selected>{{item.back}}</option> -->
                                  <option
                                    v-if="item.peilvMax*1 >= odds*1"
                                    v-for="(odds, oddsIndex) in creditOddsOptions(item, 2)"
                                    :key="oddsIndex" :value="odds">
                                    {{odds}}
                                  </option>
                                </select>
                              </td>
                            </tr>
                            <tr v-if="creditLMList.length">
                              <td class="bcg">两面</td>
                              <td colspan="7"></td>
                            </tr>
                            <tr
                              v-for="(item,index) in creditLMList"
                              :key="'LM' + item.sonProject"
                            >
                              <td class="bcg">{{item.sonProject}}</td>
                              <td>{{item.singleMin}}</td>
                              <td>{{item.singleMax}}</td>
                              <td>{{item.projectMax}}</td>
                              <td>{{item.peilvMax}}</td>
                              <td>
                                <select data-id="s_huishui" @change="changeCreditZH(item, 1, index, item.zs)" v-model="item.zs">
                                  <option :value="zs" v-for="(zs, zsIndex) in zuanshuiList" :key="zsIndex">{{zs}}</option>
                                </select>
                              </td>
                              <td>
                                <select data-id="s_odds" @change="changeCreditPL(item, 1, index, item.peilv)" v-model="item.peilv">
                                  <option
                                    v-if="item.peilvMax*1 >= odds*1"
                                    v-for="(odds, oddsIndex) in creditOddsOptions(item, 1)"
                                    :key="oddsIndex" :value="odds">
                                    {{odds}}
                                  </option>
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div style="width:49.9%;float:right;">
                        <table>
                          <thead>
                            <tr>
                              <th>项目类型</th>
                              <th>单注最低</th>
                              <th>单注最高</th>
                              <th>单项最高</th>
                              <th>赔率上限</th>
                              <th>赚水</th>
                              <th>赔率</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="bcg">三定位</td>
                              <td colspan="7"></td>
                            </tr>
                            <tr
                              sort="1108"
                              v-for="(item,index) in creditD3WList"
                              :key="item[index]"
                            >
                              <td class="bcg">{{item.sonProject}}</td>
                              <td>{{item.singleMin}}</td>
                              <td>{{item.singleMax}}</td>
                              <td>{{item.projectMax}}</td>
                              <td>{{item.peilvMax}}</td>
                              <td>
                                <select data-id="s_huishui"  @change="changeRightZH(item, 3, index, item.zs)" v-model="item.zs">
                                  <option :value="zs" v-for="(zs, zsIndex) in zuanshuiList" :key="zsIndex">{{zs}}</option>
                                </select>
                              </td>
                              <td>
                                <select data-id="s_odds"   @change="changeRightPL(item, 3, index, item.peilv)" v-model="item.peilv">
                                  <!-- <option :value="item.peilv" selected>{{item.peilv}}</option> -->
                                  <option
                                    v-if="item.peilvMax*1 >= odds*1"
                                    v-for="(odds, oddsIndex) in creditOddsOptions(item, 3)"
                                    :key="oddsIndex" :value="odds">
                                    {{odds}}
                                  </option>
                                </select>
                              </td>
                            </tr>
                            <tr v-if="creditD4WList.length">
                              <td class="bcg">四定位</td>
                              <td colspan="7"></td>
                            </tr>
                            <tr
                              sort="1108"
                              v-for="(item,index) in creditD4WList"
                              :key="item[index]"
                            >
                              <td class="bcg">{{item.sonProject}}</td>
                              <td>{{item.singleMin}}</td>
                              <td>{{item.singleMax}}</td>
                              <td>{{item.projectMax}}</td>
                              <td>{{item.peilvMax}}</td>
                              <td>
                                <select data-id="s_huishui" @change="changeRightZH(item, 4, index, item.zs)" v-model="item.zs">
                                  <option :value="zs" v-for="(zs, zsIndex) in zuanshuiList" :key="zsIndex">{{zs}}</option>
                                </select>
                              </td>
                              <td>
                                <select data-id="s_odds"  @change="changeRightPL(item, 4, index, item.peilv)" v-model="item.peilv">
                                  <option
                                    v-if="item.peilvMax*1 >= odds*1"
                                    v-for="(odds, oddsIndex) in creditOddsOptions(item, 4)"
                                    :key="oddsIndex" :value="odds">
                                    {{odds}}
                                  </option>
                                </select>
                              </td>
                            </tr>
                            <tr v-if="creditFTList.length">
                              <td class="bcg">番摊</td>
                              <td colspan="7"></td>
                            </tr>
                            <tr
                              v-for="(item,index) in creditFTList"
                              :key="'FT' + item.sonProject"
                            >
                              <td class="bcg">{{item.sonProject}}</td>
                              <td>{{item.singleMin}}</td>
                              <td>{{item.singleMax}}</td>
                              <td>{{item.projectMax}}</td>
                              <td>{{item.peilvMax}}</td>
                              <td>
                                <select data-id="s_huishui" @change="changeCreditZH(item, 1, index, item.zs)" v-model="item.zs">
                                  <option :value="zs" v-for="(zs, zsIndex) in zuanshuiList" :key="zsIndex">{{zs}}</option>
                                </select>
                              </td>
                              <td>
                                <select data-id="s_odds" @change="changeCreditPL(item, 1, index, item.peilv)" v-model="item.peilv">
                                  <option
                                    v-if="item.peilvMax*1 >= odds*1"
                                    v-for="(odds, oddsIndex) in creditOddsOptions(item, 1)"
                                    :key="oddsIndex" :value="odds">
                                    {{odds}}
                                  </option>
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <table
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        style="width:100%;text-align:center;"
                      >
                        <tfoot>
                          <tr>
                            <td style="padding-top:15px;">
                              <span class="btn grayBtn" id="submit" @click="saveForm">保存设置</span>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="myLayerFooter" style="display: block;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="取消"
                  style="display: none;"
                  @click="closeWin()"
                >取消</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="关闭"
                  style="display: inline-block;"
                  @click="closeWin()"
                >关闭</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="myWarpr" v-if="changPassword" style="">
      <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>修改密码</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div class="myLayerContent" style="width: 380px; height: auto; overflow-y: auto;">
                <table width="100%" cellspacing="0" cellpadding="0" border="0">
                  <tbody>
                    <tr>
                      <td valign="top">
                        <table id="changepwd" class="infoList">
                          <tbody>
                            <tr>
                              <td height="30" width="100" align="right">原密码&nbsp;</td>
                              <td height="30">
                                &nbsp;
                                <input
                                  name="voldpassword"
                                  class="input"
                                  style="width:130px;"
                                  autocomplete="new-password"
                                  type="password"
                                  v-model="voldpassword"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td height="30" align="right">新密码&nbsp;</td>
                              <td height="30" align="left">
                                &nbsp;
                                <input
                                  name="vnewpassword"
                                  autocomplete="new-password"
                                  class="input"
                                  style="width:130px;"
                                  type="password"
                                  v-model="vnewpassword"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td height="30" align="right">确認密码&nbsp;</td>
                              <td height="30" align="left">
                                &nbsp;
                                <input
                                  name="vrenewpassword"
                                  autocomplete="new-password"
                                  class="input"
                                  style="width:130px;"
                                  type="password"
                                  v-model="vqnewpassword"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div style="text-align: center">
                          <span style="color: red">系统提示：密码必须包含大写字母、小写字母、特殊符号 数字长度大于8位！</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="myLayerFooter" style="display: block;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="重置"
                  style="display: inline-block;"
                  @click="reset()"
                >重置</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="确定修改"
                  style="display: inline-block;"
                  @click="sure()"
                >确定修改</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="myWarpr" v-if="exit">
      <table
        class="myLayer"
        cellspacing="0"
        cellpadding="0"
        border="0"
        style="top: 333.571px; left: 851.5px;"
      >
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn" style="display: none;"></div>
              <div class="myLayerTitle">
                <h3>提示</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
              </div>
              <div
                class="myLayerContent"
                style="width: auto; height: auto; overflow-y: auto;"
              >确定退出系统吗？</div>
              <div class="myLayerFooter" style="display: block;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="取消"
                  style="display: inline-block;"
                  @click="closeWin()"
                >取消</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="确认"
                  style="display: inline-block;"
                  @click="exitWin()"
                >确认</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--
    <div id="myWarpr" v-if="tips">
      <table
        class="myLayer"
        cellspacing="0"
        cellpadding="0"
        border="0"
        style="top: 254.5px; left: 275.5px;"
      >
        <tbody>
          <tr>
            <td>
              <div class="myLayerOn"></div>
              <div class="myLayerTitle">
                <h3>第一球【0】</h3>
                <a href="javascript:;" class="myLayerClose" title="關閉"></a>
              </div>
              <div class="myLayerContent" style="width:auto;height:auto;">
                <div class="myLayerBox" id="myWarp" data-sort="1">
                  <p>
                    赔率：
                    <em name="odds_pl">10</em>下注金额：
                    <input name="uPI_M" class="input onlyNum" type="text" maxlength="5" />
                  </p>
                  <p>
                    可赢金额：
                    <em name="valueOdds" class="blue">0</em>
                  </p>
                  <p>
                    最高派彩：
                    <i>1000000</i>
                  </p>
                </div>
              </div>
              <div class="myLayerFooter" style="display: block;">
                <a
                  href="javascript:;"
                  class="btn grayBtn myLayerCancel"
                  title="取消"
                  style="display: inline-block;"
                >取消</a>
                <a
                  href="javascript:;"
                  class="btn hotBtn myLayerOk"
                  title="确认"
                  style="display: inline-block;"
                >确认</a>
              </div>
              <div class="myLayerLoading"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    -->
  </div>
</template>

<script>
import { G, moveGg, defaultPosition, coverTime } from "../../assets/js/base";
import { bindGameFun } from "../../assets/js/gamedefault";
import getData from "../getData/getData";
import axios from 'axios';
import { goLoginAfterPasswordChange, stopAllTimers } from "../../assets/js/session";
export default {
  data() {
    return {
      betLogDetail: [],
      betLogDetailFlag: false,
      actionLogDetail: [],
      actionLogDetailFlag: false,
      showIssueDetailCount: 5,
      issueDetailList: [],
      openReportDetail: {},
      openReportDetailList: [],
      reportBetDate: "",
      openPage: 1,
      centerMessage: "",
      bottomMessage: "",
      playGzMessage: "",
      messageList: [],
      dataList: [],
      token: "",
      uid: "",
      voldpassword: "",
      vnewpassword: "",
      vqnewpassword: "",
      username: "",
      ggc: false,
      jsbb: false,
      bbDetails: false,
      issueDetail: false,
      dayReportDetails: false,
      historyJiang: false,
      changRoute: false,
      playgz: false,
      xyzl: false,
      changPassword: false,
      token: "",
      uid: "",
      state: "启用",
      xyed: "",
      kyed: "",
      playLeftList: [],
      playRightList: [],
      historyList: [],
      historyCount: 0,
      historyPageSize: 10,
      popupGameList: [],
      creditGameCode: "",
      historyGameCode: "",
      playRuleGameCode: "",
      exit: false,
      centerNotice: false,
      bottomNotice: false,
      choiceUrl: "",
      speedList: [
        {
          host: "",
          name: "",
          url: "",
          time: ""
        },
        {
          host: "",
          name: "",
          url: "",
          time: ""
        },
        {
          host: "",
          name: "",
          url: "",
          time: ""
        },
        {
          host: "",
          name: "",
          url: "",
          time: ""
        },
        {
          host: "",
          name: "",
          url: "",
          time: ""
        },
      ]
    };
  },
  computed: {
    historyResultFieldMap() {
      const fields = ["sum", "dx", "ds", "lhh"];
      return fields.reduce((result, field) => {
        result[field] = this.historyList.some(item => item && item[field] !== undefined && item[field] !== null && item[field] !== "");
        return result;
      }, {});
    },
    hasHistoryResult() {
      return Object.values(this.historyResultFieldMap).some(Boolean) || this.historyFanColumns.length > 0;
    },
    historyFanColumns() {
      const columns = [];
      const columnKeys = [
        { key: "qe", title: "前二" },
        { key: "zd", title: "中肚" },
        { key: "he", title: "后二" },
        { key: "qeft", title: "前二" },
        { key: "ft", title: "中肚" },
        { key: "heft", title: "后二" }
      ];
      columnKeys.forEach(column => {
        const matched = this.historyList.find(item => item && item[column.key] !== undefined && item[column.key] !== "");
        const exists = columns.some(item => item.title === column.title);
        if (matched && !exists) {
          columns.push({
            key: column.key,
            title: column.title
          });
        }
      });
      return columns;
    },
    zuanshuiList(){
      let arr = []
      for(let i = 0; i<= 200; i++){
        arr.push(i / 1000)
      }
      return arr
    },
    odds0(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[0].peilvMax * 1), ((i * 1) * (Math.pow(10, 1))))
        arr.push((peilv * 1).toFixed(2) * 1)
      }
      return arr
    },
    odds1(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[1].peilvMax * 1), ((i * 1) * (Math.pow(10, 1))))
        arr.push((peilv * 1).toFixed(2) * 1 + '')
      }
      return arr
    },
    odds2(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[2].peilvMax * 1), ((i * 1) * (Math.pow(10, 1))))
        arr.push((peilv * 1).toFixed(2) * 1 + '')
      }
      return arr
    },
    odds3(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[3].peilvMax * 1), ((i * 1) * (Math.pow(10, 1))))
        arr.push((peilv * 1).toFixed(2) * 1 + '')
      }
      return arr
    },
    odds4(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[4].peilvMax * 1), ((i * 1) * (Math.pow(10, 1))))
        arr.push((peilv * 1).toFixed(2) * 1 + '')
      }
      return arr
    },
    odds5(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[5].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds6(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[6].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds7(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[7].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds8(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[8].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds9(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[9].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds10(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[10].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds11(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[11].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds12(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[12].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds13(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[13].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds14(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playLeftList[14].peilvMax * 1), ((i * 1) * (Math.pow(10, 2))))
        arr.push((peilv * 1).toFixed(1) * 1 + '')
      }
      return arr
    },
    odds15(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[0].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds16(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[1].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds17(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[2].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds18(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[3].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds19(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[4].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds20(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[5].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds21(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[6].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds22(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[7].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds23(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[8].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds24(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[9].peilvMax * 1), ((i * 1) * (Math.pow(10, 3))))
        arr.push((peilv * 1).toFixed(0) * 1 + '')
      }
      return arr
    },
    odds25(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[10].peilvMax * 1), ((i * 1) * (Math.pow(10, 4))))
        arr.push((peilv / 10).toFixed(0) * 10 + '')
      }
      return arr
    },
    odds26(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[11].peilvMax * 1), ((i * 1) * (Math.pow(10, 4))))
        arr.push((peilv / 10).toFixed(0) * 10 + '')
      }
      return arr
    },
    odds27(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[12].peilvMax * 1), ((i * 1) * (Math.pow(10, 4))))
        arr.push((peilv / 10).toFixed(0) * 10 + '')
      }
      return arr
    },
    odds28(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[13].peilvMax * 1), ((i * 1) * (Math.pow(10, 4))))
        arr.push((peilv / 10).toFixed(0) * 10 + '')
      }
      return arr
    },
    odds29(){
      let arr = []
      for(let i of this.zuanshuiList){
        let peilv = this.$accSub((this.playRightList[14].peilvMax * 1), ((i * 1) * (Math.pow(10, 4))))
        arr.push((peilv / 10).toFixed(0) * 10 + '')
      }
      return arr
    },
    creditD1WList(){
      return this.playLeftList.filter(item => item.playCode == "D1W")
    },
    creditD2WList(){
      return this.playLeftList.filter(item => item.playCode == "D2W")
    },
    creditD3WList(){
      return this.playRightList.filter(item => item.playCode == "D3W")
    },
    creditD4WList(){
      return this.playRightList.filter(item => item.playCode == "D4W")
    },
    creditLMList(){
      return this.playLeftList.filter(item => item.playCode == "LM")
    },
    creditFTList(){
      return this.playRightList.filter(item => item.playCode == "FT")
    },
  },
  filters: {
    dateFormate(value){
      let str = ''
      if(value){
        let date = new Date(value * 1000)
        let year = date.getFullYear()
        let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1) + ''
        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ''
        str = `${year}-${month}-${day}`
      }
      return str
    }
  },
  mounted() {
    const _this = this;
    this.token = window.sessionStorage.getItem("login").split("&")[0];
    this.uid = window.sessionStorage.getItem("login").split("&")[1];
    let data = {};
    data.access_token = this.token;
    data.uid = this.uid;
    getData.postAxiosMethod("notice", data, res => {
      _this.messageList = res.data.data;
      let topMessage = _this.messageList.filter(item => {
        return item.type == 1
      })
      let centerMessage = _this.messageList.filter(item => {
        return item.type == 2
      })
      topMessage = topMessage.sort(function(a,b){
        return b.id - a.id
      })[0]

      let bottomMessage = _this.messageList.filter(item => {
        return item.type == 3
      })
      this.centerMessage = centerMessage.sort(function(a,b){
        return b.id - a.id
      })[0]
      this.bottomMessage = bottomMessage.sort(function(a,b){
        return b.id - a.id
      })[0]
      // this.centerMessage = this.bottomMessage
      let centerGgIndex = window.sessionStorage.getItem("centerGgIndex");
      let bottomGgIndex = window.sessionStorage.getItem("bottomGgIndex");
      //跑马灯
      if (topMessage) {
        this.$event.$emit('topNotice',topMessage)
      }
      //中部
      if(centerMessage && centerGgIndex == 1){
        _this.centerNotice = true
        _this.$nextTick(function(){
          moveGg(), defaultPosition(), coverTime();
        })
      }

      //右下角
      if(bottomMessage && bottomGgIndex ==1){
        _this.bottomNotice = true
        _this.$nextTick(function(){
           $("#right-notice-box-bottom dl").css({
            bottom: "-100vh",
            right: "5px"
          })
          // $("#right-notice-box-bottom dl").animate({
          //   bottom: "-100vh",
          //   right: "5px"
          // },1000)

          $('#small_button_bottom').unbind('click').click(function(){

            _this.bottomNotice = false
            if (bottomGgIndex) {
              window.sessionStorage.setItem("bottomGgIndex", "");
              $("#right-notice-box-bottom").css({
                  "display": "none"
              })
            }

            // $("#right-notice-box-bottom dl").css({
            //   transition: 'all 1.2s',
            //   right: "-300px"
            // })
            // setTimeout(() => {
            //    _this.bottomNotice = false
            //    if (bottomGgIndex) {
            //     window.sessionStorage.setItem("bottomGgIndex", "");
            //     $("#right-notice-box-bottom").css({
            //         "display": "none"
            //     })
            // }
            // }, 1500);
          })
        })
      }

    });

    setTimeout(() => {
      bindGameFun(_this);
    }, 1000);

    this.$event.$on("betLogDetail", (log) => {

      this.betLogDetail = JSON.parse(log.content)
      const defaultPrecision = this.getPeilvDefaultPrecision(log.playCode)
      this.betLogDetail.forEach(item => {
        item.peilv = this.formatPeilv(item.peilv, defaultPrecision)
      })
      this.betLogDetailFlag = true
    })

    this.$event.$on("actionLogDetail", (log) => {
    this.actionLogDetail = JSON.parse(log.content)
      this.actionLogDetailFlag  = true
    })
  },
  methods: {
    showMoreIssueDetail(){
      this.$loading_show()
      setTimeout(() => {
        this.$loading_hide()
        this.showIssueDetailCount += 5
      }, 500);

    },
    toIssueDetail(item){
      let _this = this
      if (item) {
        this.openReportDetail = Object.assign({}, item);
      }
      let beforeDate = this.reportBetDate || this.normalizeReportBetDate(this.openReportDetail.betDate)
      this.closeWin()
      this.$loading_show()
      let data = {
        access_token: this.token,
        uid: this.uid,
        game_code: this.openReportDetail.code || this.openReportDetail.game_code || this.openReportDetail.gameCode || window.sessionStorage.getItem("code") || 'hn5fc',
        beforeDate,

      }
      setTimeout(() => {
        getData.postAxiosMethod("issuereport", data, res => {
          this.$loading_hide()
          _this.issueDetailList = res.data.data;
          _this.issueDetail = true
        });
      }, 300);
    },
    backToReport(){
      this.closeWin()
      let data = {};
      data.access_token = this.token;
      data.uid = this.uid;
      let _this = this
      this.$loading_show()
      getData.postAxiosMethod("report", data, res => {
        this.$loading_hide()
        _this.dataList = res.data.data;
        this.jsbb = true;
      });
    },
    reportDetail(item){
      this.showIssueDetailCount = 5
      this.closeWin()
      this.$loading_show()
      this.reportBetDate = this.normalizeReportBetDate(item.betDate);
      this.openReportDetail = Object.assign({}, item, {
        betDate: this.reportBetDate
      });
      let data = {
        access_token: this.token,
        uid: this.uid,
        betDate: item.betDate
      };
      this.ensurePopupGameList(() => {
        getData.postAxiosMethod("dayReport", data, res => {
          this.$loading_hide()
          const detailData = res.data.data;
          const detailList = Array.isArray(detailData) ? detailData : (detailData ? [detailData] : []);
          this.openReportDetailList = detailList.map(detail => {
            const row = Object.assign({}, detail);
            row.betDate = row.betDate || this.reportBetDate;
            row.gameName = this.getReportGameName(row);
            return row;
          });
          if (!this.openReportDetail.gameName) {
            this.openReportDetail.gameName = this.getReportGameName(this.openReportDetail);
          }
          this.bbDetails = true
        });
      });
    },
    normalizeReportBetDate(value) {
      if (value === undefined || value === null || value === "") {
        return "";
      }
      const text = String(value).trim();
      if (!text) {
        return "";
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
        return text;
      }
      if (/^\d{8}$/.test(text)) {
        return `${text.slice(0, 4)}-${text.slice(4, 6)}-${text.slice(6, 8)}`;
      }
      const normalized = text.replace(/\./g, "-").replace(/\//g, "-");
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        const year = parsed.getFullYear();
        const month = `${parsed.getMonth() + 1}`.padStart(2, "0");
        const day = `${parsed.getDate()}`.padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      return text;
    },
    sum(list, key){
      let sum = 0;
      list.forEach(item => {
        if(key == 'num'){
        }
        if (item && Object.prototype.hasOwnProperty.call(item, "ispei") && item.ispei != 1) {
          return;
        }
        sum += ((item && item[key] ? item[key] : 0) * 1)
      })
      return sum || 0
    },
    getReportFieldValue(item, keys, fallback = 0) {
      if (!item || typeof item !== "object") {
        return fallback;
      }
      for (let i = 0; i < keys.length; i++) {
        const value = item[keys[i]];
        if (value !== undefined && value !== null && value !== "") {
          return value;
        }
      }
      return fallback;
    },
    getDayReportBackValue(item) {
      return this.getReportFieldValue(item, ["back", "backMoney", "rebateMoney", "waterMoney"], 0);
    },
    getDayReportBackTotal(list) {
      return (list || []).reduce((total, item) => {
        if (item && Object.prototype.hasOwnProperty.call(item, "ispei") && item.ispei != 1) {
          return total;
        }
        return total + (this.getDayReportBackValue(item) * 1 || 0);
      }, 0);
    },
    formatReportNumber(value, keepDecimal = true) {
      const number = value * 1;
      if (isNaN(number)) {
        return "0";
      }
      if (!keepDecimal || number === 0) {
        return `${number}`;
      }
      return number.toFixed(2);
    },
    formatHistoryTime(value) {
      if (value === undefined || value === null || value === "") {
        return "";
      }
      const timestamp = Number(value);
      if (Number.isNaN(timestamp) || timestamp <= 0) {
        return String(value);
      }
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      const hour = `${date.getHours()}`.padStart(2, "0");
      const minute = `${date.getMinutes()}`.padStart(2, "0");
      const second = `${date.getSeconds()}`.padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    getCurrentGameCode() {
      return window.sessionStorage.getItem("code") || "";
    },
    getPopupGameCode(item) {
      if (!item || typeof item !== "object") {
        return "";
      }
      return item.code || item.gameCode || item.game_code || item.id || "";
    },
    getPopupGameName(item) {
      if (!item || typeof item !== "object") {
        return "";
      }
      return item.gameName || item.name || item.menu || item.title || this.getPopupGameCode(item);
    },
    getReportGameCode(item) {
      if (!item || typeof item !== "object") {
        return "";
      }
      return item.gameCode || item.game_code || item.code || "";
    },
    getReportGameName(item) {
      const gameCode = this.getReportGameCode(item);
      const gameInfo = this.popupGameList.find(game => this.getPopupGameCode(game) == gameCode);
      if (gameInfo) {
        return this.getPopupGameName(gameInfo);
      }
      return item.gameName || gameCode || sessionStorage.getItem("gameName");
    },
    getPopupGameData() {
      return {
        access_token: window.sessionStorage.getItem("login").split("&")[0],
        uid: window.sessionStorage.getItem("login").split("&")[1]
      };
    },
    ensurePopupGameList(callback) {
      if (this.popupGameList.length) {
        if (callback) {
          callback();
        }
        return;
      }
      const data = this.getPopupGameData();
      getData.postAxiosMethod("gamelist", data, res => {
        this.popupGameList = Array.isArray(res.data.data) ? res.data.data : [];
        if (callback) {
          callback();
        }
      });
    },
    requestHistoryOpenInfo(gameCode, page) {
      const _this = this;
      let data = this.getPopupGameData();
      data.game_code = gameCode || this.getCurrentGameCode();
      data.page = page || 1;
      data.limit = this.historyPageSize;
      this.$loading_show()
      getData.postAxiosMethod("openinfo", data, res => {
        this.$loading_hide()
        const list = _this.normalizeHistoryList(res.data.data, data.game_code);
        const currentPage = res.data.currentPage || data.page;
        _this.openPage = (currentPage * 1) + 1;
        _this.historyCount = res.data.count || list.length;
        if (data.page == 1) {
          _this.historyList = list;
        } else {
          _this.historyList = _this.historyList.concat(list);
        }
        this.historyJiang = true;
      });
    },
    requestPlayRuleInfo(gameCode) {
      const _this = this;
      let data = this.getPopupGameData();
      data.game_code = gameCode || this.getCurrentGameCode();
      this.$loading_show()
      getData.postAxiosMethod("introduction", data, res => {
        this.$loading_hide()
        _this.playGzMessage = res.data.data.guize;
        this.playgz = true;
      });
    },
    changeHistoryGame() {
      this.openPage = 1;
      this.historyCount = 0;
      this.historyList = [];
      this.requestHistoryOpenInfo(this.historyGameCode, 1);
    },
    changePlayRuleGame() {
      this.playGzMessage = "";
      this.requestPlayRuleInfo(this.playRuleGameCode);
    },
    getHistoryNumbers(item) {
      if (!item || typeof item !== "object") {
        return [];
      }
      if (Array.isArray(item.open_number)) {
        return item.open_number.map(num => String(num));
      }
      if (Array.isArray(item.openNumbers)) {
        return item.openNumbers.map(num => String(num));
      }
      const openCode = item.openCode || item.open_code || item.opencode || item.openNum;
      if (typeof openCode === "string" && openCode) {
        return openCode
          .split(",")
          .map(num => num.trim())
          .filter(num => num !== "");
      }
      const numbers = [];
      ["q1", "q2", "q3", "q4", "q5"].forEach(key => {
        if (item[key] !== undefined && item[key] !== null && item[key] !== "") {
          numbers.push(String(item[key]));
        }
      });
      return numbers;
    },
    normalizeHistoryItem(item) {
      const openNumbers = this.getHistoryNumbers(item);
      const result = item && item.result && typeof item.result === "object" ? item.result : null;
      return {
        ...item,
        qihao: item.qihao || item.issue || item.issueNo || item.issue_no || "",
        timeStamp: String(item.timeStamp || item.create_time || item.openTime || item.open_time || ""),
        openNumbers,
        q1: openNumbers[0],
        q2: openNumbers[1],
        q3: openNumbers[2],
        q4: openNumbers[3],
        q5: openNumbers[4],
        hasResult: !!result,
        sum: result && result.sum !== undefined ? result.sum : "",
        dx: result && result.dx !== undefined ? result.dx : "",
        ds: result && result.ds !== undefined ? result.ds : "",
        lhh: result && result.lhh !== undefined ? result.lhh : "",
        qe: result && result.qe !== undefined ? result.qe : "",
        zd: result && result.zd !== undefined ? result.zd : "",
        he: result && result.he !== undefined ? result.he : "",
        qeft: result && result.qeft !== undefined ? result.qeft : "",
        heft: result && result.heft !== undefined ? result.heft : "",
        ft: result && result.ft !== undefined ? result.ft : ""
      };
    },
    normalizeHistoryList(payload, gameCode) {
      const currentCode = gameCode || this.historyGameCode || this.getCurrentGameCode();
      if (Array.isArray(payload)) {
        if (payload.length && payload[0] && Array.isArray(payload[0].list)) {
          const matchedGame = payload.find(item => {
            const itemCode = item.code || (item.game_info && item.game_info.code);
            return itemCode === currentCode;
          }) || payload[0];
          const list = matchedGame && Array.isArray(matchedGame.list) ? matchedGame.list : [];
          return list.map(item => this.normalizeHistoryItem(item));
        }
        const filteredList = payload.filter(item => {
          if (!item || typeof item !== "object") {
            return false;
          }
          const itemCode = item.code || item.game_code || item.gameCode || (item.game_info && item.game_info.code);
          return !itemCode || itemCode === currentCode;
        });
        return filteredList.map(item => this.normalizeHistoryItem(item));
      }
      if (payload && typeof payload === "object") {
        const values = Object.values(payload);
        const matchedGame = values.find(item => item && item.code === currentCode);
        if (matchedGame && Array.isArray(matchedGame.list)) {
          return matchedGame.list.map(item => this.normalizeHistoryItem(item));
        }
        const matchedListHolder = values.find(item => item && Array.isArray(item.list));
        if (matchedListHolder) {
          return matchedListHolder.list.map(item => this.normalizeHistoryItem(item));
        }
        if (Array.isArray(payload.list)) {
          return payload.list.map(item => this.normalizeHistoryItem(item));
        }
        if (Array.isArray(payload.records)) {
          return payload.records.map(item => this.normalizeHistoryItem(item));
        }
      }
      return [];
    },
    isFourDecimalPeilvPlay(playCode) {
      return playCode == "LM" || playCode == "FT";
    },
    getPeilvDefaultPrecision(playCode) {
      return this.isFourDecimalPeilvPlay(playCode) || playCode == "D1W" ? 2 : 1;
    },
    formatPeilv(peilv, defaultPrecision = 2, maxPrecision = 4) {
      const number = peilv * 1;
      if (isNaN(number)) {
        return "-";
      }
      const str = peilv == null ? "" : peilv.toString();
      return str
        .replace(/(\.\d*?[1-9])0+$/, "$1")
        .replace(/\.0+$/, "");
    },
    saveForm() {
      let str = "";
      let odds = this.playLeftList.concat(this.playRightList);
      odds.forEach(item => {
        if (item.playCode) {
          str += `${item.playCode}:${item.sonProject}:${item.zs}` + ",";
        }
      });
      let data = {};
      data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      data.code = this.creditGameCode || window.sessionStorage.getItem("code");
      data.odds = str.slice(0, str.length - 1);
      this.$loading_show()
      getData.postAxiosMethod("odds/editodds", data, res => {
        this.$loading_hide()
        this.xyzl = false;
        this.$event.$emit('updateOdds')
        this.$nextTick(function(){
          G.alert({
            content: "保存成功",
            ok: function() {
              return true;
            },
            type: "1"
          });
        })
      });
    },
    normalizeCreditOdds(odds) {
      const order = ["D1W", "D2W", "D3W", "D4W", "LM", "FT"];
      let list = [];
      if (Array.isArray(odds)) {
        list = odds;
      } else if (odds && typeof odds === "object") {
        order.forEach(playCode => {
          if (Array.isArray(odds[playCode])) {
            list = list.concat(odds[playCode].filter(item => item && item.playCode == playCode));
          }
        });
      }

      return list.map(item => {
        const data = Object.assign({}, item);
        data.back = data.back == null ? "0" : data.back;
        data.singleMin = data.singleMin == null ? "" : data.singleMin;
        data.singleMax = data.singleMax == null ? "" : data.singleMax;
        data.projectMax = data.projectMax == null ? "" : data.projectMax;
        data.peilvMax = data.peilvMax == null ? 0 : data.peilvMax;
        data.num = data.num == null ? "" : data.num;
        data.peilv = ((data.peilv || 0) * 1) + "";
        data.zs = (data.back * 1) + "";
        return data;
      });
    },
    getCreditNum(item, multiple) {
      const num = item && item.num !== "" && item.num != null ? item.num * 1 : Math.pow(10, multiple);
      return isNaN(num) || num === 0 ? Math.pow(10, multiple) : num;
    },
    getDecimalLength(value) {
      const str = (value == null ? "" : value).toString();
      const parts = str.split(".");
      return parts[1] ? parts[1].replace(/0+$/, "").length : 0;
    },
    getRawDecimalLength(value) {
      const str = (value == null ? "" : value).toString();
      const parts = str.split(".");
      return parts[1] ? parts[1].length : 0;
    },
    formatCreditPeilv(peilv, item, preserveTrailingZero) {
      const precision = Math.min(
        Math.max(this.getRawDecimalLength(item.peilvMax), this.getRawDecimalLength(item.peilv), this.getDecimalLength(item.num) + 3),
        6
      );
      const number = peilv * 1;
      if (isNaN(number)) {
        return "";
      }
      const formatted = number.toFixed(precision);
      return preserveTrailingZero ? formatted : (formatted * 1).toString();
    },
    calcCreditPeilv(item, multiple, zs) {
      const peilvMax = (item.peilvMax || 0) * 1;
      const num = this.getCreditNum(item, multiple);
      let peilv = this.$accSub(peilvMax, ((zs == null ? item.zs : zs) * 1) * num) * 1;
      if (peilv > peilvMax) peilv = peilvMax;
      return this.formatCreditPeilv(peilv, item);
    },
    calcCreditZs(item, multiple) {
      const num = this.getCreditNum(item, multiple);
      const precision = Math.min(
        Math.max(3, this.getRawDecimalLength(item.peilvMax), this.getRawDecimalLength(item.peilv), this.getDecimalLength(item.num) + 3),
        6
      );
      return (this.$accDiv(this.$accSub(item.peilvMax * 1, item.peilv * 1), num).toFixed(precision) * 1).toString();
    },
    creditOddsOptions(item, multiple) {
      const arr = [];
      this.zuanshuiList.forEach(zs => {
        arr.push(this.calcCreditPeilv(item, multiple, zs));
      });
      const currentPeilv = this.formatCreditPeilv(item.peilv, item, true);
      if (currentPeilv && arr.indexOf(currentPeilv) == -1) {
        arr.unshift(currentPeilv);
      }
      return arr;
    },
    changeCreditZH(item, multiple, index, zs){
      let peilv = this.calcCreditPeilv(item, multiple)

      if(index == 0){
        this.playLeftList.concat(this.playRightList).forEach(ele => {
          if(ele.playCode == item.playCode){
            ele.zs = zs
            ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
          }
        })
      }else{
        item.peilv = peilv
      }
    },
    changeCreditPL(item, multiple, index, pl){
      let zs = this.calcCreditZs(item, multiple)
      if(index == 0){
        this.playLeftList.concat(this.playRightList).forEach(ele => {
          if(ele.playCode == item.playCode){
            ele.zs = zs
            ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
          }
        })
      }else{
        item.zs = zs
      }
    },
    changeLeftZH(item, multiple, index, zs){
      let peilv = this.calcCreditPeilv(item, multiple)

      if(index == 0){
        if(multiple == 1){
          this.playLeftList.forEach((ele, n) => {
            if(ele.playCode == "D1W"){
              ele.zs = zs
              ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
            }
          })
        }else{
          this.playLeftList.forEach((ele, n) => {
            if(ele.playCode == "D2W"){
              ele.zs = zs
              ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
            }
          })
        }
      }else{
        item.peilv = peilv
      }
    },
    changeRightZH(item, multiple, index, zs){
      let peilv = this.calcCreditPeilv(item, multiple)

      if(index == 0){
        if(multiple == 3){
          this.playRightList.forEach((ele, n) => {
            if(ele.playCode == "D3W"){
              ele.zs = zs
              ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
            }
          })
        }else{
          this.playRightList.forEach((ele, n) => {
            if(ele.playCode == "D4W"){
              ele.zs = zs
              ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
            }
          })
        }

      }else{
        item.peilv = peilv
      }
    },
    changeLeftPL(item, multiple, index, pl){
      let zs = this.calcCreditZs(item, multiple)

      if(index == 0){
        if(multiple == 1){
          this.playLeftList.forEach((ele, n) => {
            if(ele.playCode == "D1W"){
              ele.zs = zs
              ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
            }
          })
        }else {
          this.playLeftList.forEach((ele, n) => {
            if(ele.playCode == "D2W"){
              ele.zs = zs
              ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
            }
          })
        }

      }else{
        item.zs = zs
      }
    },
    changeRightPL(item, multiple, index, pl){
      let zs = this.calcCreditZs(item, multiple)
      if(index == 0){
        if(multiple == 3){
          this.playRightList.forEach((ele, n) => {
            if(ele.playCode == "D3W"){
              ele.zs = zs
              ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
            }
          })
        }else{
          this.playRightList.forEach((ele, n) => {
            if(ele.playCode == "D4W"){
              ele.zs = zs
              ele.peilv = this.calcCreditPeilv(ele, multiple, zs)
            }
          })
        }

      }else{
        item.zs = zs
      }
    },
    exitWin() {
      // window.sessionStorage.setItem("login", "");
      sessionStorage.clear()
      window.location.href = "/";
    },
    changeCreditGame() {
      this.requestCreditInfo(this.creditGameCode);
    },
    requestCreditInfo(gameCode) {
      const _this = this;
      let data = {};
      data.access_token = window.sessionStorage
        .getItem("login")
        .split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      data.code = gameCode || window.sessionStorage.getItem("code");
      this.creditGameCode = data.code;
      this.$loading_show()
      getData.postAxiosMethod("creditsinfo", data, res => {
        this.$loading_hide()
        _this.username = res.data.data.username;
        _this.kyed = res.data.data.balance;
        _this.xyed = res.data.data.credits;
        _this.state = res.data.data.status == 1 ? "启用" : "封禁";
        const odds = this.normalizeCreditOdds(res.data.data.odds);
        _this.playLeftList = odds.filter(item => item.playCode == "D1W" || item.playCode == "D2W" || item.playCode == "LM");
        _this.playRightList = odds.filter(item => item.playCode == "D3W" || item.playCode == "D4W" || item.playCode == "FT");
        this.xyzl = true;
      });
    },
    openWin(title) {
      const _this = this;
      this.closeWin();
      if (title == "结算报表") {
        let data = {};
        data.access_token = this.token;
        data.uid = this.uid;
        this.$loading_show()
        getData.postAxiosMethod("report", data, res => {
          this.$loading_hide()
          _this.dataList = res.data.data;
          this.jsbb = true;
        });

      } else if (title == "信用资料") {
        this.creditGameCode = window.sessionStorage.getItem("code");
        this.ensurePopupGameList(() => {
          this.requestCreditInfo(this.creditGameCode);
        });
      } else if (title == "修改密码") {
        this.changPassword = true;
      } else if (title == "历史开奖") {
        this.historyGameCode = this.getCurrentGameCode();
        this.ensurePopupGameList(() => {
          this.requestHistoryOpenInfo(this.historyGameCode);
        });

      } else if (title == "玩法规则") {
        this.playRuleGameCode = this.getCurrentGameCode();
        this.ensurePopupGameList(() => {
          this.requestPlayRuleInfo(this.playRuleGameCode);
        });
      } else if (title == "线路切换") {
        this.cs()
      } else if (title == "公告") {
        this.ggc = true;
      } else if (title == "安全退出") {
        this.exit = true;
      }
    },
    closeWin() {
      this.ggc = false;
      this.jsbb = false;
      this.bbDetails = false;
      this.issueDetail = false;
      this.dayReportDetails = false;
      this.historyJiang = false;
      this.changRoute = false;
      this.playgz = false;
      this.xyzl = false;
      this.changPassword = false;
      this.exit = false;
      this.betLogDetailFlag = false;
      this.actionLogDetailFlag  = false;
    },
    loadMore() {
      if (this.historyList.length >= this.historyCount) {
        return;
      }
      this.requestHistoryOpenInfo(this.historyGameCode || this.getCurrentGameCode(), this.openPage);
    },
    reset() {
      this.voldpassword = "";
      this.vnewpassword = "";
      this.vqnewpassword = "";
    },
    sure() {
      const _this = this;
      let data = {},
        pageNum = 0;
      data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      getData.postAxiosMethod("userinfo", data, res => {
        _this.username = res.data.data.username;
        sessionStorage.setItem('Voice', res.data.data.isplayer)
      });
      setTimeout(() => {
        if (this.voldpassword && this.vnewpassword == this.vqnewpassword) {
          let data = {};
          data.username = this.username;
          data.password = this.voldpassword;
          data.newpwd = this.vnewpassword;
          getData.postAxiosMethod("newpwd", data, res => {
            this.changPassword = false;
            this.$nextTick(function(){
              if (res.data.code == -104) {
                G.alert({
                  content: res.data.msg,
                  ok: function() {
                    return true;
                  },
                  type: "1"
                });
              } else {
                stopAllTimers();
                G.alert({
                  content: "密码修改成功,请重新登录!",
                  ok: function() {
                    goLoginAfterPasswordChange();
                    return true;
                  },
                  type: "1"
                });
              }
            })

          });
        } else {
          this.changPassword = false;
          this.$nextTick(function(){
            G.alert({
              content: "请输入密码或者新密码两次输入不一致",
              ok: function() {
                return true;
              },
              type: "1"
            });
          })

        }
      }, 1000);
    },
    async cs(){
      this.$loading_show()
        getData.postAxiosMethod("speedList", {}, res => {
          res.data.data.forEach((item, index) => {
          let startDate = new Date()
          axios.post(item.url, {}, {timeout: 1000 * 3}).then(res => {
            let endDate = new Date()
            let time = endDate.getTime() - startDate.getTime()
            this.speedList[index] = {
              host: item.host,
              name: item.name,
              url: item.url,
              time,
            }
            this.speedList = JSON.parse(JSON.stringify(this.speedList))
          })
        })
          this.$loading_hide()
          this.changRoute = true;
        });
    },
    changeSure(){
      if(this.choiceUrl && this.choiceUrl != ""){
        let url = this.choiceUrl + "/#/?"
        // let url = 'localhost:8080' + "/#/?"
        let parameter = "";

        var sessionKeys = Object.keys(sessionStorage)
        for(let i of sessionKeys){
          parameter += `${i}=${sessionStorage.getItem(i).replace("&", "%26")}&`
        }
        url += parameter.substring(0, parameter.length - 1)
        location.href = url
      }
    }
  }
};
</script>
<style>
@font-face{
font-family:'FontAwesome';
src:url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.eot?v=4.1.0');
src:url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.eot?#iefix&v=4.1.0') format('embedded-opentype'), url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.woff?v=4.1.0') format('woff'), url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.ttf?v=4.1.0') format('truetype'), url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.svg?v=4.1.0#fontawesomeregular') format('svg');
font-weight:normal;font-style:normal;
}
[class*='icon-']:before{display:inline-block;font-family:"FontAwesome";font-weight:normal;font-style:normal;vertical-align:baseline;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.footer {
  position: absolute;
  top: 0;
  width: 100%;
}
.myLayer{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.myLayerOn {
  display: none !important;
}
#small_button.icon-up, #small_button_bottom.icon-up{
  text-align: center;
  font-size: 18px;
  color: #FFF;
  background: none !important;
  height: 40px !important;
  width: 40px !important;
}
#small_button.icon-up::before, #small_button_bottom.icon-up::before{
  content:"\f00d";
}
.history-open-number {
  display: inline-block;
  min-width: 20px;
  height: 20px;
  margin: 0 2px;
  padding: 0 4px;
  border: 1px solid #c9d6e2;
  border-radius: 10px;
  background: #fff;
  color: #d13b00;
  font-weight: bold;
  line-height: 20px;
  text-align: center;
}
</style>
